module.exports = __webpack_public_path__ + "img/TruPath-9.416f0607.jpg";